
export const mirandaMediaArray = [
  {
    _id: 'mirandaMediaId1',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `If you're having a "Piano-Key Chic" theme party, I've got a dress`,
      `If you're having a "Safari Chic" theme party, I've got a dress`,
      `If you're having a "Skeleton-Costume Chic" theme party, I've got a dress`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId2',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Can redheads pull off brown?`,
      `Passions include, wearing brown, brick facades, and traveling`,
      `Off to the airport, where should we go?`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId3',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend I'm thinking something profound`,
      `Warning: wears dangly earrings to trick people into thinking I'm girly`,
      `The dimmer the lighting the better you look`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId4',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `I'm known for`,
      `Woke up like this`
    ],
    subcaptions: [
      `Emergency: Forgot how to be charming`,
      `Overthinking everything, per usual`,
      `Oh no did I forget to buy ice cream at the grocery store`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId5',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Focusing hard on whether to order the cheese plate or the chocolate cake`,
      `Is the jury looking at me because they have to or because they think I'm hot`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId6',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Go on, try to find an asymmetry`,
      `My "I just saw a little dog try to hump a big dog" face` 
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId7',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-7-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "I just saw a dog pee on someone I don't like" face`,
      `My "I just saw a little dog try to hump a big dog" face`,
      `My "about to order a chocolate croissant" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId8',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-8-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Warning: will freak out at pigeons`,
      `Yes, I still read the physical newspaper`,
      `Hidden talent: freaking out at pigeons`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId9',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-9-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Pretending to be someone who wears jewelry and drinks from crystal Champagne flutes`,
      `Options include 'classy', 'fabulous', and 'beguiling'`,
      `My "1920s Flapper-Chic" look`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId10',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-10-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `How I fight the Sunday scaries`,
      `Me and my best friend`
    ],
    subcaptions: [
      `Against all odds I have fashionable friends`,
      `Showing you I have hot friends and therefore must be hot too`,
      `Hot by the transitive property of having hot friends`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId11',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-11-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `My vulnerable side`,
      `Life outtake`
    ],
    subcaptions: [
      `My "I'm still at the office at midnight" face`,
      `My "How do I pretend this is a work call" face`,
      `Out of court settlement: Achieved.`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId12',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-12-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `How I fight the Sunday scaries`,
      `Me and my best friend`
    ],
    subcaptions: [
      `Against all odds I have fashionable friends`,
      `Showing you I have hot friends and therefore must be hot too`,
      `Hot by the transitive property of having hot friends`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId13',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-13-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `Lowkey flex`,
      `Woke up like this`
    ],
    subcaptions: [
      `Compliments expected as scientifically orange and blue are complementary colors`,
      `Does this dress bring out my boobs, I mean eyes`,
      `Warning: you might be too distracted by my... biceps... to look me in the eye`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'mirandaMediaId14',
    userId: 'mirandaUserId',
    email: 'miranda@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-14-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Dating me will look like`,
      `Me and my best friend`
    ],
    subcaptions: [
      `Warning: four people to impress, not just one`,
      `Looking fabulous is best when shared`,
      `Walking down Fifth Avenue like`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]